// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Logo-wrapper[data-v-3f8df2e5]{position:relative}img[data-v-3f8df2e5]{left:0;z-index:2}.Logo-bg[data-v-3f8df2e5],img[data-v-3f8df2e5]{position:absolute}.Logo-bg[data-v-3f8df2e5]{left:2px;top:2px;border-radius:74px;overflow:hidden;z-index:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
